import React, { Component } from 'react';
import { observer } from 'mobx-react';
import VideoUploadService from '../services/VideoUploadService';
import VideoUploadDialog from './VideoUploadDialog';

class VideoUploadDialogContainer extends Component {
  render() {
    return <VideoUploadDialog values={VideoUploadService.form.getValues()} isOpen={VideoUploadService.isOpen} />;
  }
}

export default observer(VideoUploadDialogContainer);
